/**
 * Copyright © 2020-21 Robert Bosch Engineering and Business Solutions Private Limited. All Rights Reserved.
   NOTICE:  All information contained herein is, and remains the property of Robert Bosch Engineering and Business Solutions Private
   Limited. Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is
   obtained from Robert Bosch Engineering and Business Solutions Private Limited.
*/

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateProfileComponent } from './create-profile/create-profile.component';
import { ManageProfileComponent } from './manage-profile/manage-profile.component';
import { ProfilesRoutingModule } from './profiles-routing.module';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { ConfigureProfileComponent } from './configure-profile/configure-profile.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';

/**
  * @ngdoc overview
  * @name MODULE_NAME.module:ProfilesModule
  *
  * @description
  * This module has the information of feature modules, Angular material modules, external modules and
    the components that belong to this module
  *
*/
@NgModule({
  declarations: [CreateProfileComponent, ManageProfileComponent, ConfigureProfileComponent],
  imports: [
    CommonModule,
    ProfilesRoutingModule,
    SharedModule,
    TranslateModule,
    MatTableModule,
    MatPaginatorModule,
    MatButtonModule,
    MatSelectModule,
    MatCardModule,
    MatMenuModule,
    FormsModule,
    MatExpansionModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    MatInputModule,
    MatCheckboxModule
  ]
})
export class ProfilesModule { }
